if (!customElements.get('subcollection-pills')) {
  customElements.define(
    'subcollection-pills',
    class SubcollectionPills extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('.slider');
        this.slideTrack = this.querySelector('.slider__slide-track');
        this.prevButton = this.querySelector('.slider-button--prev');
        this.nextButton = this.querySelector('.slider-button--next');

        if (!this.slider || !this.slideTrack || !this.prevButton || !this.nextButton) {
          return;
        }

        this.resizeObserver = new ResizeObserver(() => this.updateArrowVisibility());
        this.init();
      }

      init() {
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.slideTrack);

        window.addEventListener('resize', () => this.updateArrowVisibility());
        this.slideTrack.addEventListener('scroll', () => this.updateArrowVisibility());

        this.prevButton.addEventListener('click', () => this.scroll(-0.8));
        this.nextButton.addEventListener('click', () => this.scroll(0.8));

        this.updateArrowVisibility();
        setTimeout(() => this.updateArrowVisibility(), 100);
      }

      scroll(factor) {
        const scrollAmount = this.slider.clientWidth * factor;
        this.slideTrack.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }

      updateArrowVisibility() {
        this.prevButton.style.display = this.slideTrack.scrollWidth > this.slider.clientWidth ? 'flex' : 'none';
        this.nextButton.style.display = this.prevButton.style.display;

        this.prevButton.disabled = this.slideTrack.scrollLeft <= 0;
        this.nextButton.disabled = this.slideTrack.scrollLeft >= this.slideTrack.scrollWidth - this.slider.clientWidth;
      }
    }
  );
}
